import Cookie from "js-cookie";
const GetCookies = (cookieName) => {
  return Cookie.get(cookieName);
};

export default GetCookies;
